import * as React from "react"
import '../styles/header.scss'
import {useState,useEffect} from 'react'
import window from 'global'
import ScrollspyNav from "react-scrollspy-nav";
import { navigate } from 'gatsby';
import { Navbar,Nav } from 'react-bootstrap'
import { useLocation } from '@reach/router';

const Header = ({navtoggle}) => {
  

 const [isMobile, setIsMobile] = useState(window.innerWidth < 994);
 const [isToggle, setIsToggle] = useState(false);
 const hrefName=['/#about','/#skillset','/#brand','/#partner','/#careers','/#contact']
 const location = useLocation();
 function toggle(url){
    if(isMobile===true){
      setIsToggle(!isToggle);
    }
    if(location.pathname==='/privacy/' && url!=="menu"){
      
      navigate('/')
      setTimeout(function(){ 
        navigate(hrefName[url])
      }, 2000);
      
    }
 }
 

  useEffect(() => {
  
  
        window.addEventListener("resize", () => {
          const ismobile = window.innerWidth < 980;
          if (ismobile !== isMobile) setIsMobile(ismobile);
          var element = document.getElementById("responsive-navbar-nav");
          if(ismobile===false){
            if(element.classList.contains('show'))
            {
              setIsToggle(false)
            }
        
          }
          else{
           
            if(element.classList.contains('show'))
            {
              setIsToggle(true)
            }
            

          }
         }, false);
         var lastScrollTop = 0;
          document.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
            var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
            let ele=document.getElementById('nav-shadow');
            if (st > lastScrollTop || st===0){
              ele.style.boxShadow="none"
            } 
            else {
              ele.style.boxShadow="0px 4px 16px rgba(0, 0, 0, 0.1)"
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
            
          }, false);
          navtoggle(isToggle)
         
  
  }, [isMobile,isToggle,navtoggle]);
  
  
  
  return(
    <div className="container navbar-header">
       
      <ScrollspyNav
        scrollTargetIds={[
          "home",
          "about",
          "skillset",
          "brand",
          "partner",
          "careers",
          "contact"
        ]}
        activeNavClass="active"
        headerBackground="true"
  
   
      >
    <Navbar id="nav-shadow" className={`${isMobile ? "xs-header" : "lg-header"} ${isToggle?"scroll-action":"header-bg"}`}  collapseOnSelect expand="lg" >
            <Navbar.Brand smooth className="mx-4 mx-lg-5" href="#home">
            <img src="/logo.svg"alt="A Gatsby astronaut"/>
            </Navbar.Brand>
            
          <Navbar.Toggle  onClick={() => toggle('menu')}  aria-controls="responsive-navbar-nav">
              <a href={() => false} class="navbar-toggler collapsed border-0" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                  <img  alt="line1" src="/line_1.png"/>
                  <img  alt="line2" src="/line_2.png"/>
              </a>              
          </Navbar.Toggle>
 
 
  <Navbar.Collapse id="responsive-navbar-nav" className={`justify-content-around`}>
  
      <Nav className="mx-auto text-center nav-items">
    
        <Nav.Link onClick={() => toggle(0)} href="#about"    className="pt-5 ps-0 pt-lg-1" >About</Nav.Link>
        <Nav.Link onClick={() => toggle(1)}  href="#skillset" className="pt-3 ps-0 ps-lg-4  pt-lg-1"  >Skillsets</Nav.Link>
        <Nav.Link onClick={() => toggle(2)}  href="#brand" className="pt-3 ps-0 ps-lg-4 pt-lg-1" >Our Brands</Nav.Link>
        <Nav.Link onClick={() => toggle(3)}  href="#partner" className="pt-3 ps-0 ps-lg-4 pt-lg-1" >Partners</Nav.Link>
        <Nav.Link onClick={() => toggle(4)}  href="#careers" className="pt-3 ps-0 ps-lg-4 pt-lg-1" >Careers</Nav.Link>
        <Nav.Link onClick={() => toggle(5)}  href="#contact" className="pt-3 ps-0 ps-lg-4 pt-lg-1" >Contact</Nav.Link>
      </Nav>
   <Nav>
  
   <Nav.Link onClick={() =>toggle(5)}  smooth href="#contact"  className="speak-btn mx-lg-5 mx-auto nav-link  mt-lg-0 ">
     Speak to us</Nav.Link>
  
   </Nav>
  </Navbar.Collapse>
</Navbar>
</ScrollspyNav>
</div>

  )
}


export default Header



